import { Component, OnInit } from '@angular/core';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from '../../services/UnitsService';
import { MatDialog } from '@angular/material/dialog';
import { UnitsDearchComponent } from '../units-dearch/units-dearch.component';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.css'],
})
export class UnitsComponent implements OnInit {
  unCode = '';
  unName = '';
  unArName = '';
  unrach = '1';
  userID = 'sa';
  modifiedDate = '2021-01-01';
  compCode = '1';

  constructor(
    public UnitsService: UnitsService,
    public units: UnitsModel,
    public unitSelectedData: UnitsModel,
    public storage: LocalStorageService,
    private dialogref: MatDialog
  ) { }

  ngOnInit(): void { }

  retriveUnits() {
    this.UnitsService.getUnits(this.unCode, this.compCode).subscribe((data: UnitsModel) => {
      this.unName = data.unName;
      this.unArName = data.unArName;
      this.unrach = data.unrach;
      this.compCode = data.compCode;
      this.userID = data.userID;
      this.modifiedDate = data.modifiedDate;
    }
    );
  }
  deleteUnits() {
    this.UnitsService.delUnits(this.unCode, this.compCode).subscribe((data: UnitsModel) => {
      this.unCode = data.unCode;
      this.unName = data.unName;
      this.unArName = data.unArName;
      this.unrach = data.unrach;
      this.compCode = data.compCode;
      this.userID = data.userID;
      this.modifiedDate = data.modifiedDate;
    }
    );
  }

  NewData() {
    this.unCode = '';
    this.unName = '';
    this.unArName = '';
    this.unrach = '1';
    this.userID = 'sa';
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');;
    this.compCode = '1';
  }

  submitUnits() {
    this.units.unCode = this.unCode;
    this.units.unName = this.unName;
    this.units.unArName = this.unArName;
    this.units.unrach = this.unrach;
    this.units.userID = this.storage.retrieve('stguserId');
    this.units.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.units.compCode = this.storage.retrieve('stgcompCode');

    this.UnitsService.AddUnit(this.units).subscribe(
      (data) => {
        this.mesgSave() ;
      },
      (error) => {
        alert(error);
      }
    );
  }

  openDialogs(): void {
    const dialogRef = this.dialogref.open(UnitsDearchComponent,
      {
        data: {
          dataKey: this.unitSelectedData
        },
        width:'80%'
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.unCode = result.unCode;
        this.unName = result.unName;
        this.unArName = result.unArName;
        this.unrach = result.unrach;
        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifiedDate = result.modifiedDate;
        dialogSubmitSubscription.unsubscribe();
      });

  }

  mesgDelete() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
      this.deleteUnits();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
}
